import {Injectable, OnInit, ViewChild} from '@angular/core';

@Injectable()
export class AlertService {

}
